import io from 'socket.io-client';
import feathers from '@feathersjs/feathers';
import socketio from '@feathersjs/socketio-client';
import authentication from '@feathersjs/authentication-client';

// const socket = io('http://localhost:3030/');   // local
const socket = io('https://ccautoworld-api-41e948d0b293.herokuapp.com/');

const app = feathers();

app.configure(socketio(socket, { timeout: 30000 }));
app.configure(authentication({
    storage: window.localStorage
}));

export default app;